import styled, { keyframes } from 'styled-components'

// TODO(AM): Attribute Loader https://codepen.io/tashfene/pen/raEqrJ?q=loader&limit=all&type=type-pens
const loaderAnimation = keyframes`
    0% {
        transform: rotate(0deg);
    }
  
    25% {
        transform: rotate(180deg);
    }
  
    50% {
        transform: rotate(180deg);
    }
  
    75% {
        transform: rotate(360deg);
    }
  
    100% {
        transform: rotate(360deg);
    }
`

const loaderFillAnimation = keyframes`
    0% {
        height: 0%;
    }
    
    25% {
        height: 0%;
    }
    
    50% {
        height: 100%;
    }
    
    75% {
        height: 100%;
    }
    
    100% {
        height: 0%;
    }
`

export const Loader = styled.span`
    display: inline-block;
    width: 40px;
    height: 40px;
    border: 4px solid #fff;
    animation: ${loaderAnimation} 2s infinite ease;
`

export const LoaderFill = styled.span`
    vertical-align: top;
    display: inline-block;
    width: 100%;
    background-color: #fff;
    animation: ${loaderFillAnimation} 2s infinite ease-in;
`



// WEBPACK FOOTER //
// ./src/components/Loader.styles.js